<template>
  <span class="label" :style="spanStyle">
    <span v-if="locationData">
      {{locationData.name}}
    </span>
    <span v-else>
      -
    </span>
  </span>
</template>

<script>
import ColourMixin from '@/mixins/colour'

export default {
  name: 'LabelAccountLocationBadge',
  mixins: [ColourMixin],
  props: {
    accountLocation: Object,
    accountLocationId: Number
  },
  computed: {
    locationData() {
      var locationId = this.accountLocationId || (this.accountLocation ? this.accountLocation.id : null)

      // Try account location list in store to access info
      if(locationId && this.$store.state.account.accountLocations) {
        var accountLocation = this.$store.state.account.accountLocations.find(location => location.id == locationId)
        if(accountLocation) {
          return accountLocation
        }
      }

      return {
        id: 0,
        name: 'Unknown',
        highlightColour: null
      }
    },
    spanStyle() {
      var highlightColour = this.locationData.highlightColour

      if(highlightColour) {
        return {
          'background-color': highlightColour,
          color: this.textColourForBackground(highlightColour)
        }
      }
      return {}
    }
  },
}
</script>
